import { Box, Skeleton, Stack } from '@mui/material';

export const FullWidthLayoutSkeleton: React.FC = () => (
  <Stack bgcolor="background.paper" sx={{ height: '100vh', width: '100vw' }}>
    <Skeleton variant="rectangular" width="100%" height={64} animation="wave" />

    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />
    </Box>
  </Stack>
);
